export class SearchObjectResult<T> {

  public results: T[] = [];
  public count: number;
  public totalCount: number;
  public page: number;
  public totalPages: number;
  public pageSize: number;

  static fromDto<T>(s: any, objectMapper: (o: any) => T): SearchObjectResult<T> {
    const search = new SearchObjectResult<T>();

    search.results    = s.results?.map(objectMapper);
    search.count      = s.count;
    search.totalCount = s.total_count;
    search.page       = s.page;
    search.totalPages = s.total_pages;
    search.pageSize   = s.page_size;

    return search;
  }

  static map<T, U>(searchResult: SearchObjectResult<T>, objectMapper: (T) => U): SearchObjectResult<U> {
    const search = new SearchObjectResult<U>();

    search.results    = searchResult.results.map(objectMapper);
    search.count      = searchResult.count;
    search.totalCount = searchResult.totalCount;
    search.page       = searchResult.page;
    search.totalPages = searchResult.totalPages;
    search.pageSize   = searchResult.pageSize;

    return search;
  }
}
